import RectangleButton from '@/components/molecules/rectangleButton'

const ButtonGroup = ({ bookFacilitiesLink, membershipLink }) => {
  return (
    <div className="flex flex-col gap-y-detailsMobile lg:gap-y-detailsDesktop mt-[50px] lg:mt-0">
      <RectangleButton
        name="BOOK FACILITIES"
        target="_blank"
        link={bookFacilitiesLink}
        color="secondary"
      />
      <RectangleButton
        name="JOIN OUR MEMBERSHIP"
        target="_blank"
        link={membershipLink}
        color="secondary"
      />
    </div>
  )
}

export default ButtonGroup
